import React from "react"

import BlockList from "./BlockList"
import Contact from "./Contact"
import ContactBlock from "./ContactBlock"
import FeaturedClient from "./FeaturedClient"
import Hero from "./Hero"
import Iconetextecitationimage from "./Iconetextecitationimage"
import ImageWithListBlock from "./ImageWithListBlock"
import IphoneModule from "./IphoneModule"
import JobOffers from "./JobOffers"
import KpiBlock from "./KpiBlock"
import LogosGallery from "./LogosGallery"
import OurTeam from "./OurTeam"
import SliderBlock from "./SliderBlock"
import SmartHero from "./SmartHero"
import TitleBlock from "./TitleBlock"
import ClientsList from "./list/Clients"
import PostsList from "./list/Posts"

const renderSwitch = (component, locale) => {
  switch (component.fieldGroupName) {
    case "Page_Pagecontent_Components_Iconetextecitationimage":
      return <Iconetextecitationimage component={component} />
    case "Page_Pagecontent_Components_ImageWithListBlock":
      return <ImageWithListBlock component={component} />
    case "Page_Pagecontent_Components_Hero":
      return <Hero component={component} />
    case "Page_Pagecontent_Components_SmartHero":
      return <SmartHero component={component} />
    case "Page_Pagecontent_Components_SliderBlock":
      return <SliderBlock component={component} />
    case "Page_Pagecontent_Components_TitleBlock":
      return <TitleBlock component={component} />
    case "Page_Pagecontent_Components_ContactBlock":
      return <ContactBlock component={component} />
    case "Page_Pagecontent_Components_FeaturedClient":
      return <FeaturedClient component={component} />
    case "Page_Pagecontent_Components_BlockList":
      return <BlockList component={component} />
    case "Page_Pagecontent_Components_Posts":
      return <PostsList component={component} locale={locale} />
    case "Page_Pagecontent_Components_Clients":
      return <ClientsList component={component} locale={locale} />
    case "Page_Pagecontent_Components_IphoneModule":
      return <IphoneModule component={component} />
    case "Page_Pagecontent_Components_OurTeam":
      return <OurTeam component={component} />
    case "Page_Pagecontent_Components_JobOffers":
      return <JobOffers component={component} locale={locale} />
    case "Page_Pagecontent_Components_ContactForm":
      return <Contact component={component} />
    case "Page_Pagecontent_Components_LogosGallery":
      return <LogosGallery component={component} />
    case "Page_Pagecontent_Components_KpiBlock":
      return <KpiBlock component={component} />
    default:
      return <br />
  }
}

function Blocks(props) {
  const { components, locale } = props
  return (
    <div>
      {components.map((component, key) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={component.fieldGroupName + key}>
          {renderSwitch(component, locale)}
        </div>
      ))}
    </div>
  )
}

export default Blocks
